import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import zh from './zh_cn';
// import en from './en_us';
// import zh_tw from './zh_tw';

Vue.use(VueI18n)
let lang = navigator.language || navigator.browserLanguage;
let default_command = ''
if(lang == 'zh' || lang == 'zh-CN') {
  default_command = 'zh'  
}else if(lang == 'zh-TW') {
  default_command = 'zh_tw'
}else {
  default_command = 'en'
}
// console.log(lang,'xxxxxxxxxxx');
// sessionStorage.setItem('locale_place',default_command)
localStorage.setItem('locale_place',default_command)
console.log(localStorage.getItem('locale') , sessionStorage.getItem('locale_place'),'xxxx');
// 注册i18n实例并引入语言文件
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || localStorage.getItem('locale_place'),
  // locale: sessionStorage.getItem('locale') || sessionStorage.getItem('locale_place'),
  messages: {
    'zh': require('./zh_cn.js'),
    'en': require('./en_us.js'),
    'zh_tw': require('./zh_tw.js')
//  'zh': zh,
//   'en':en,
//   'zh_tw': zh_tw
  }
})

export default i18n


// WEBPACK FOOTER //
// ./src/i18n/index.js